import { useState, useEffect } from 'react';
import { Grid, Box, Gift, Award, Users, ChevronsLeft, ChevronDown, ChevronUp, User, ArrowRight, AlertCircle, Sparkles, Trophy, Clock, History, TrendingUp, Zap, X   } from 'lucide-react';

// Компонент карточки пользователя
const UltraModernCard = ({
                             node,
                             type = "partner",
                             cloneNumber,
                             size = "medium",
                             hideDate = false,
                             onGoUp,
                             onGoDown,
                             onShowHistory,
                             onAscendent, // ДОБАВЛЕНО
                             onCancelBron

                         }) => {
    const sizeClasses = {
        small: {
            card: "h-20 sm:h-24 max-w-full",
            avatarWrapper: "w-10 sm:w-12 h-10 sm:h-12",
            avatarBorder: "w-12 sm:w-14 h-12 sm:h-14",
            avatarText: "text-xs sm:text-sm",
            badge: "text-[8px] sm:text-[9px] px-1 sm:px-1.5 py-0.5 -right-0.5 sm:-right-1 -top-0.5 sm:-top-1",
            typeTag: "text-[8px] sm:text-[9px] px-1 sm:px-1.5 py-0.5 -left-0.5 sm:-left-1 -top-0.5 sm:-top-1",
            loginText: "text-[10px] sm:text-xs",
            date: "text-[7px] sm:text-[8px]",
            cloneTag: "text-[8px] sm:text-[9px]",
            historyBtn: "w-5 h-5 sm:w-6 sm:h-6",
            historyIcon: 10,
            navBtn: "pr-2 pl-1.5 py-1",
            navIcon: 10,
            navText: "text-[9px]",
        },
        medium: {
            card: "h-32 sm:h-40 max-w-full",
            avatarWrapper: "w-16 sm:w-20 h-16 sm:h-20",
            avatarBorder: "w-20 sm:w-24 h-20 sm:h-24",
            avatarText: "text-lg sm:text-xl",
            badge: "text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 sm:py-1 -right-1 sm:-right-2 -top-1 sm:-top-2",
            typeTag: "text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 sm:py-1 -left-1 sm:-left-2 -top-1 sm:-top-2",
            loginText: "text-xs sm:text-sm",
            date: "text-[10px] sm:text-xs",
            cloneTag: "text-[10px] sm:text-xs",
            historyBtn: "w-7 h-7 sm:w-8 sm:h-8",
            historyIcon: 14,
            navBtn: "pr-2.5 pl-2 py-1.5",
            navIcon: 12,
            navText: "text-[10px]",
        },
        large: {
            card: "h-40 sm:h-48 md:h-52 max-w-full",
            avatarWrapper: "w-20 sm:w-24 md:w-28 h-20 sm:h-24 md:h-28",
            avatarBorder: "w-24 sm:w-28 md:w-32 h-24 sm:h-28 md:h-32",
            avatarText: "text-2xl sm:text-2xl md:text-3xl",
            badge: "text-xs sm:text-sm px-2 sm:px-2.5 py-0.5 sm:py-1 -right-1.5 sm:-right-2 -top-1.5 sm:-top-2",
            typeTag: "text-xs sm:text-sm px-2 sm:px-2.5 py-0.5 sm:py-1 -left-1.5 sm:-left-2 -top-1.5 sm:-top-2",
            loginText: "text-sm sm:text-base",
            date: "text-xs sm:text-sm",
            cloneTag: "text-xs sm:text-sm",
            historyBtn: "w-9 h-9 sm:w-10 sm:h-10",
            historyIcon: 18,
            navBtn: "pr-3 pl-2 py-1.5",
            navIcon: 14,
            navText: "text-xs",
        }
    };

    const s = sizeClasses[size];

    let mainGradient, bgGradient, textColor, borderColor, typeText;

    if (!node.filled) {
        mainGradient = "from-gray-200 to-gray-300";
        bgGradient = "from-white to-gray-100";
        textColor = "text-gray-500";
        borderColor = "border-gray-200";
        typeText = "";
    }
    // Технический клон - ФИОЛЕТОВЫЙ
    else if (node.cloneType === 'technical' || type === 'technical-clone') {
        mainGradient = "from-purple-600 to-indigo-600";
        bgGradient = "from-purple-50 to-indigo-50";
        textColor = "text-purple-700";
        borderColor = "border-purple-400/40";
        typeText = "ТЕХ КЛОН";
    }
    // Персональный клон - ЗЕЛЕНЫЙ
    else if (node.cloneType === 'personal' || type === 'personal-clone') {
        mainGradient = "from-emerald-500 to-teal-400";
        bgGradient = "from-emerald-50 to-teal-50";
        textColor = "text-emerald-600";
        borderColor = "border-emerald-300/30";
        typeText = "КЛОН";
    }
    // Обычный клон (на случай если тип не определен) - ЗЕЛЕНЫЙ
    else if (type === 'clone') {
        mainGradient = "from-emerald-500 to-teal-400";
        bgGradient = "from-emerald-50 to-teal-50";
        textColor = "text-emerald-600";
        borderColor = "border-emerald-300/30";
        typeText = "КЛОН";
    }
    // Корневой узел - СИНИЙ
    else if (type === 'root') {
        mainGradient = "from-blue-500 to-blue-600";
        bgGradient = "from-blue-50 to-blue-100/50";
        textColor = "text-blue-500";
        borderColor = "border-blue-500/20";
        typeText = "КОРНЕВОЙ";
    }
    // По умолчанию (обычный аккаунт) - СИНИЙ
    else {
        mainGradient = "from-blue-500 to-blue-600";
        bgGradient = "from-blue-50 to-blue-100/50";
        textColor = "text-blue-500";
        borderColor = "border-blue-500/20";
        typeText = "АККАУНТ";
    }

    // ДОБАВЛЕНО: Проверка на наличие асцендента
    const showAscButton = node.filled && node.ascendent && node.ascendent !== false && node.ascendent.link && type !== 'technical-clone' && node.isRootPosition;
    const isUpgradeAsc = showAscButton && node.ascendent.is_upgrade;

    // ✅ ДОБАВЬТЕ ЭТУ ОТЛАДКУ:
    console.log('UltraModernCard Debug:', {
        login: node.login,
        filled: node.filled,
        hasAsc: !!node.ascendent,
        ascData: node.ascendent,
        showAscButton: showAscButton,
        onAscendent: !!onAscendent
    });

    return (
        <div className={`relative ${s.card} w-full rounded-xl sm:rounded-2xl transition-all duration-500 transform hover:-translate-y-1 hover:shadow-xl group`}>
            <div className={`absolute inset-0 bg-gradient-to-br ${bgGradient} rounded-xl sm:rounded-2xl shadow-lg overflow-hidden border ${borderColor}`}></div>
            <div className="absolute inset-0 flex items-center justify-center">
                <div className={`w-2/3 h-2/3 rounded-full bg-gradient-to-br ${mainGradient} opacity-5 filter blur-xl group-hover:opacity-10 transition-opacity duration-500`}></div>
            </div>

            <div className="relative h-full z-10 flex flex-col items-center justify-center p-2 sm:p-3">
                {node.filled && typeText && (
                    <div className={`absolute ${s.typeTag} bg-gradient-to-r ${mainGradient} text-white font-bold rounded-md sm:rounded-lg shadow-lg z-20`}>
                        {typeText}
                    </div>
                )}

                {/* Кнопка истории в правом верхнем углу */}
                {node.filled && onShowHistory && (
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onShowHistory(node);
                        }}
                        className={`absolute top-1 sm:top-2 right-1 sm:right-2 ${s.historyBtn} bg-white rounded-full shadow-md hover:shadow-lg transition-all hover:scale-110 flex items-center justify-center z-20 border border-gray-200`}
                        title="История позиции">
                        <History size={s.historyIcon} className="text-blue-500" />
                    </button>
                )}

                <div className={`relative ${s.avatarBorder} flex items-center justify-center`}>
                    <div className={`absolute inset-0 rounded-full bg-gradient-to-r ${mainGradient} opacity-20 transform group-hover:scale-105 transition-transform duration-500`}></div>
                    <div className={`${s.avatarWrapper} rounded-full bg-white shadow-lg overflow-hidden relative z-10 border-2 ${borderColor} flex items-center justify-center group-hover:scale-105 transition-transform duration-500`}>
                        {node.avatar ? (
                            <img src={node.avatar} alt={node.login || 'User'} className="w-full h-full object-cover" />
                        ) : node.filled && node.login ? (
                            <div className={`w-full h-full flex items-center justify-center bg-gradient-to-br ${mainGradient}`}>
                <span className={`${s.avatarText} font-bold text-white`}>
                    {node.login.charAt(0).toUpperCase()}
                </span>
                            </div>
                        ) : (
                            <div className="w-full h-full flex items-center justify-center bg-gray-100">
                                <Plus size={size === "small" ? 14 : size === "medium" ? 24 : 36} />
                            </div>
                        )}
                    </div>
                </div>

                {node.filled ? (
                    <div className={`mt-2 sm:mt-3 font-medium ${s.loginText} ${textColor} text-center`}>
                        {node.login}
                    </div>
                ) : (
                    <div className={`mt-2 sm:mt-3 font-medium ${s.loginText} text-gray-400 text-center`}>
                        Свободно
                    </div>
                )}

                {!hideDate && node.filled && node.installDate && (
                    <div className={`${s.date} text-gray-400 mt-0.5 sm:mt-1`}>
                        {node.installDate}
                    </div>
                )}

                {node.filled && type === 'clone' && cloneNumber && (
                    <div className={`absolute bottom-1 sm:bottom-2 right-1 sm:right-2 ${s.cloneTag} bg-gradient-to-r ${mainGradient} text-white font-bold px-1.5 sm:px-2 py-0.5 rounded-full shadow-sm`}>
                        #{cloneNumber}
                    </div>
                )}

                {/* Кнопки навигации */}
                {node.filled && (
                    <>
                        {/* ✅ НОВОЕ: Кнопка апгрейда НАВЕРХУ (отдельно) */}
                        {showAscButton && onAscendent && (
                            <div className="absolute -top-8 sm:-top-10 left-1/2 transform -translate-x-1/2 z-30">

                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        console.log('Going to ascendent:', node.ascendent);
                                        onAscendent(node.ascendent);
                                    }}
                                    className={`group ${
                                        isUpgradeAsc
                                            ? 'bg-gradient-to-r from-yellow-500 to-amber-500'
                                            : 'bg-gradient-to-r from-purple-500 to-indigo-600'
                                    } text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center gap-1 border-2 border-white ${s.navBtn}`}
                                    title={isUpgradeAsc ? "Переход на уровень апгрейда" : "Восхождение"}
                                >
                                    <div className="bg-white/20 rounded-full p-0.5">
                                        {isUpgradeAsc ? (
                                            <Zap size={s.navIcon}
                                                 className="group-hover:scale-110 transition-transform"/>
                                        ) : (
                                            <TrendingUp size={s.navIcon}
                                                        className="group-hover:-translate-y-0.5 transition-transform"/>
                                        )}
                                    </div>
                                    <span className={`font-semibold whitespace-nowrap ${s.navText}`}>
                                        {isUpgradeAsc ? 'Апгрейд' : 'Восх.'}
                                    </span>
                                </button>
                            </div>
                        )}

                        {/* Кнопки ВНИЗУ: Вверх и Вниз */}
                        <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 z-30 flex gap-1">
                            {/* Кнопка вверх - только для корневой позиции */}
                            {node.isRootPosition && onGoUp && node.canGoUp && (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        console.log('Going up from root node:', node);
                                        onGoUp(node);
                                    }}
                                    className={`group bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center gap-1 border-2 border-white ${s.navBtn}`}
                                    title="Подняться вверх"
                                >
                                    <div className="bg-white/20 rounded-full p-0.5">
                                        <ChevronUp size={s.navIcon} className="group-hover:-translate-y-0.5 transition-transform" />
                                    </div>
                                    <span className={`font-semibold whitespace-nowrap ${s.navText}`}>
                                        Вверх
                                    </span>
                                </button>
                            )}

                            {/* Кнопка вниз - для НЕкорневых позиций */}
                            {!node.isRootPosition && onGoDown && node.canGoDown && (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        console.log('Going down from node:', node);
                                        onGoDown(node);
                                    }}
                                    className={`group bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center gap-1 border-2 border-white ${s.navBtn}`}
                                    title="Спуститься вниз"
                                >
                                    <div className="bg-white/20 rounded-full p-0.5">
                                        <ChevronDown size={s.navIcon} className="group-hover:translate-y-0.5 transition-transform" />
                                    </div>
                                    <span className={`font-semibold whitespace-nowrap ${s.navText}`}>
                                        Вниз
                                    </span>
                                </button>
                            )}
                            {/* ✅ НОВОЕ: Кнопка отмены брони для ПУСТЫХ позиций С АКТИВНОЙ БРОНЬЮ */}
                            {!node.filled && node.can_cancel_bron && onCancelBron && (
                                <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 z-30">
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            console.log('Cancelling bron for node:', node);
                                            onCancelBron(node);
                                        }}
                                        className={`group bg-gradient-to-r from-red-500 to-red-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center gap-1 border-2 border-white ${s.navBtn}`}
                                        title="Отменить бронь"
                                    >
                                        <div className="bg-white/20 rounded-full p-0.5">
                                            <X size={s.navIcon} className="group-hover:rotate-90 transition-transform" />
                                        </div>
                                        <span className={`font-semibold whitespace-nowrap ${s.navText}`}>
                            Отменить
                        </span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const Plus = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
);

export { UltraModernCard, Plus };
